module.exports = __webpack_public_path__ + "img/so.5583e0f6.svg";